export default __webpack_public_path__ + "static/media/all-darwins-icon.7180a559.svg";